<template>
  <div class="space-y-16">
    <div class="grid grid-cols-4 gap-16">
      <p class="text-static-default-mid body-1 col-span-1">
        {{ i18n(translations.firstName) }}
      </p>
      <p class="body-1 col-span-3">
        {{ stakeholder.firstName }}
      </p>
    </div>

    <div class="grid grid-cols-4 gap-16">
      <p class="text-static-default-mid body-1 col-span-1">
        {{ i18n(translations.lastName) }}
      </p>
      <p class="body-1 col-span-3">
        {{ stakeholder.lastName }}
      </p>
    </div>

    <div class="grid grid-cols-4 gap-16">
      <p class="text-static-default-mid body-1 col-span-1">
        {{ i18n(translations.dateOfBirth) }}
      </p>
      <p class="body-1 col-span-3">
        {{ formatDate(stakeholder.dateOfBirth) }}
      </p>
    </div>

    <div class="grid grid-cols-4 gap-16">
      <p class="text-static-default-mid body-1 col-span-1">
        {{ i18n(translations.countryOfCitizenship) }}
      </p>
      <p class="body-1 col-span-3">
        {{ stakeholder.countryOfCitizenship }}
      </p>
    </div>

    <div class="grid grid-cols-4 gap-16">
      <p class="text-static-default-mid body-1 col-span-1">
        {{ i18n(translations.phoneNumber) }}
      </p>
      <p class="body-1 col-span-3">
        {{ stakeholder.phoneNumber }}
      </p>
    </div>

    <div class="grid grid-cols-4 gap-16">
      <p class="text-static-default-mid body-1 col-span-1">
        {{ i18n(translations.countryOfResidency) }}
      </p>
      <p class="body-1 col-span-3">
        {{ stakeholder.countryOfResidency }}
      </p>
    </div>
  </div>

  <div class="mt-16 grid grid-cols-4 gap-16">
    <p class="text-static-default-mid body-1 col-span-1">
      {{ i18n(translations.address) }}
    </p>
    <p class="body-1 col-span-3">
      {{ formatAddress(stakeholder.address) }}
    </p>
  </div>

  <!-- Government ID field -->
  <div class="mt-16 grid grid-cols-4 gap-16">
    <p class="text-static-default-mid body-1 col-span-1">
      {{ i18n(translations.governmentIssuedIdentification) }}
    </p>
    <div class="body-1 col-span-3">
      <p class="flex items-center gap-2">
        <IconAttachment class="mr-2" />
        {{ stakeholder.identityDocument?.front?.filename ?? '' }}
      </p>
      <p
        v-if="stakeholder.identityDocument?.back"
        class="flex items-center gap-2"
      >
        <IconAttachment class="mr-2" />
        {{ stakeholder.identityDocument.back?.filename ?? '' }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconAttachment } from '@ds/icons/IconAttachment'

import type { Stakeholder as StakeholderType } from '~/api/kyb/types'

import translations from './StakeholderInfo.translations'

type Stakeholder = Partial<StakeholderType>

defineProps<{
  stakeholder: Stakeholder
}>()

const i18n = useI18n()

const formatDate = (dateString?: string): string => {
  if (!dateString) return ''

  return new Date(dateString).toLocaleDateString()
}

const formatAddress = (
  address?: Partial<{
    addressLine1: string
    addressLine2: string | null
    postalCode: string
    city: string
    country: string
    stateOrProvince: string | null
  }>,
): string => {
  if (!address) return ''

  const parts = [
    address.addressLine1 ?? '',
    address.addressLine2 ?? '',
    `${address.postalCode ?? ''} ${address.city ?? ''}`,
    address.stateOrProvince ?? '',
    address.country,
  ].filter(Boolean)

  return parts.join(', ')
}
</script>
